module.exports = __webpack_public_path__ + "static/media/vain-emoji-svgrepo-com.4f81620b.svg";